/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Contact_DescriptionInputs */

const en_meta_contact_description = /** @type {(inputs: Meta_Contact_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book a 30-minute discovery call about AI automation for your business, or write to us. One recent example is enough to start. We reply within one working day.`)
};

const lv_meta_contact_description = /** @type {(inputs: Meta_Contact_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piesakiet 30 minūšu sarunu par AI automatizāciju Jūsu uzņēmumā vai rakstiet mums. Pietiek ar vienu nesenu piemēru. Atbildam vienas darba dienas laikā.`)
};

/**
* | output |
* | --- |
* | "Book a 30-minute discovery call about AI automation for your business, or write to us. One recent example is enough to start. We reply within one working day." |
*
* @param {Meta_Contact_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_contact_description = /** @type {((inputs?: Meta_Contact_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Contact_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_contact_description(inputs)
	return en_meta_contact_description(inputs)
});